const autoNgTemplateLoaderTemplate1 = require('./services-table.html');

import angular from 'angular';

angular.module('shbdeployer.kubernetes').component('kubernetesApplicationServicesTable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    services: '<',
    application: '<',
    publicUrl: '<',
  },
});
